module.exports = __webpack_public_path__ + "media/assets/community/badge-osc-tutuor-f33b5d787a44bc7b599ab05c1eab254c2e9d0e80c7520a103593c338969d93f7.png";